import React from "react";
import { siteConfig } from "../siteConfig";
import ServiceCard from "../components/ServiceCard";
import Reveal from "../components/Reveal";

const ServicesPage = () => (
  <>
    <section className="pt-32 pb-16" style={{ backgroundColor: siteConfig.colors.dark }}>
      <div className="max-w-4xl mx-auto px-5 md:px-8 text-center">
        <div className="text-xs font-bold uppercase tracking-widest mb-3" style={{ color: siteConfig.colors.primary }}>What We Do</div>
        <h1 className="font-display font-black text-white leading-tight" style={{ fontSize: "clamp(2rem,5vw,3.5rem)" }}>
          Our Services
        </h1>
        <p className="mt-4 text-white/60 text-lg max-w-2xl mx-auto">
          From paver patios to full landscape redesigns — we handle every aspect of your outdoor project.
        </p>
      </div>
    </section>

    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {siteConfig.services.map((s, i) => (
            <Reveal key={s.slug} delay={i * 90}>
              <ServiceCard service={s} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>

  </>
);

export default ServicesPage;
